import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'KEYWORD_FORM'
export const KeywordFormAction = createFormAction(FORM_KEY)